import { Component, OnInit, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'lib-service-agreement',
  templateUrl: './service-agreement.component.html',
  styleUrls: ['./service-agreement.component.scss']
})
export class ServiceAgreementComponent implements OnInit {
  showActionButtons: boolean = true;
  appSubscriptionAgreement: any;
  appSubscriptionAgreementRaw: any;
  appAgreementRaw: any;
  appAgreement: any;
  passedData: any;
  enableActionFirst: boolean = false;
  enableActionSecond: boolean = false;
  enableActionFirstSuccess: boolean = false;
  enableActionSecondSuccess: boolean = false;
  consentValueCheck: any = {};
  indexValue: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ServiceAgreementComponent>,
    private sanitizer: DomSanitizer) { }
  @HostListener("window:scroll", [])
  
  ngOnInit() {
    this.showActionButtons = this.passedData.showActionButtons;
    this.appSubscriptionAgreement = this.sanitizer.bypassSecurityTrustHtml((this.passedData.data.document).replace('html{zoom:.55}', ''));
    this.appAgreement = this.sanitizer.bypassSecurityTrustHtml((this.passedData.data.dataDocument).replace('html{zoom:.55}', ''));
    this.appSubscriptionAgreementRaw = this.passedData.data.document;
    this.appAgreementRaw = this.passedData.data.dataDocument;
    if (this.appSubscriptionAgreement && this.appSubscriptionAgreement == '') {
      this.enableActionFirst = true;
      this.enableActionFirstSuccess = true;
      this.indexValue = 1;
    }
    if (this.appAgreement && this.appAgreement == '') {
      this.enableActionSecond = true;
      this.enableActionSecondSuccess = true;
      this.indexValue = 0;
    }
  }

  onChangeEvent(event) {
    this.indexValue = event;
  }

  updateFirstTab(event) {
    if (event.checked) {
      this.indexValue = 1;
      this.enableActionFirstSuccess = true;
    } else {
      this.enableActionFirstSuccess = false;
    }
  }

  updateSecondTab(event) {
    if (event.checked) {
      this.enableActionSecondSuccess = true;
    } else {
      this.enableActionSecondSuccess = false;
    }
  }

  onScroll(event): void {
    if ((Math.ceil(event.target.offsetHeight + event.target.scrollTop) + 5) >= event.target.scrollHeight && this.indexValue == 0) {
      this.enableActionFirst = true;
    }
    if ((Math.ceil(event.target.offsetHeight + event.target.scrollTop) + 5) >= event.target.scrollHeight && this.indexValue == 1) {
      this.enableActionSecond = true;
    }
  }

  onCloseDialog() {
    this.dialogRef.close({ event: 'concentcancel' });
  }

  selectPlan() {
    this.dialogRef.close({ event: 'agree', serviceAgreement: this.appSubscriptionAgreementRaw, dataUsageAgreement: this.appAgreementRaw });
  }
}
